import React from 'react'

import { Button, Steps } from 'antd'

//
import { AdminTask, TaskStatus } from 'core/application/adminDashboard/adminTasks'

import { useBreakPoints } from 'common/hooks'

import BallotCheck from 'assets/images/icons/ballot-check.svg'
import CreditCard from 'assets/images/icons/credit-card.svg'
import FileSignatureRegular from 'assets/images/icons/file-signature-regular.svg'
import PaperPlane from 'assets/images/icons/paper-plane.svg'
import Pencil from 'assets/images/icons/pencil.svg'
import UserEdit from 'assets/images/icons/user-edit.svg'
import UserPlus from 'assets/images/icons/user-plus.svg'
import Users from 'assets/images/icons/users.svg'

type SetupProgressStepsProps = {
  steps: AdminTask[]
  activeStep: number
  renewalYear?: string
  isLoading?: (taskId: number) => boolean
  onStepClick?: (taskId: number) => void
}

function SetupProgressSteps({ steps, activeStep, renewalYear = '', isLoading, onStepClick }: SetupProgressStepsProps) {
  return (
    <Steps className="profile-setup" direction="vertical" current={activeStep}>
      {steps.map((item, index) => (
        <Steps.Step
          key={index}
          title={
            <StepBody
              key={item.id}
              step={item}
              renewalYear={renewalYear}
              disabled={item.status !== TaskStatus.Active}
              loading={isLoading && isLoading(item.id)}
              onClick={() => {
                if (onStepClick) {
                  onStepClick(item.id)
                }
              }}
            />
          }
        />
      ))}
    </Steps>
  )
}

export default SetupProgressSteps

const getIcon = (type: string): string => {
  switch (type) {
    case 'ballot-check':
      return BallotCheck
    case 'user-edit':
      return UserEdit
    case 'user-plus':
      return UserPlus
    case 'file-signature-regular':
      return FileSignatureRegular
    case 'paper-plane':
      return PaperPlane
    case 'pencil':
      return Pencil
    case 'credit-card':
      return CreditCard
    case 'users':
      return Users
    default:
      return BallotCheck
  }
}

type StepBodyProps = {
  step: AdminTask
  disabled: boolean
  loading?: boolean
  onClick: any
  renewalYear: string
}

function StepBody({ step, disabled, loading = false, renewalYear, onClick }: StepBodyProps) {
  const { isMd } = useBreakPoints()
  return (
    <div className="profile-setup__step p-16 mb-8">
      <div className="profile-setup__step-label pr-8">
        <img className={'icon mr-8'} src={getIcon(step.icon)} />
        <h6 className="gray-7 mb-0" style={step.status === TaskStatus.Done ? { textDecoration: 'line-through' } : {}}>
          {step.description.replace('{{year}}', `${renewalYear}`)}
        </h6>
      </div>

      {step.status !== TaskStatus.Done && (
        <Button type="primary" disabled={disabled} loading={loading} onClick={onClick}>
          {isMd ? step.name : step.name.split(' ')[0]}
        </Button>
      )}

      {step.status === TaskStatus.Done && step.allowReview && (
        <Button type="primary" loading={loading} onClick={onClick}>
          Review &amp; Edit
        </Button>
      )}
    </div>
  )
}
